import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconCircleFull: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconCircleFull" {...props}>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
      <path d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z" />
    </svg>
  </IconSVG>
)
